/** @flow */

import { completeRequest, beginRequest } from "@store/utils";
import type { SystemAccessState } from "./types";

const startRequest = beginRequest(["requestsInProgress"]);
const finishRequest = completeRequest(["requestsInProgress"]);

export const setLoading = (state: SystemAccessState) => () => {
  return {
    ...startRequest(state),
  };
};

export const setLoaded = (state: SystemAccessState) => () => {
  return {
    ...finishRequest(state),
  };
};

export const onUpdateDataSecurityGeneralSettings = (state: SystemAccessState) => () =>
  startRequest(state);

export const onUpdateDataSecurityGeneralSettingsSuccess = (state: SystemAccessState) => () =>
  finishRequest(state);

export const onUpdateDataSecurityGeneralSettingsError = (state: SystemAccessState) => () =>
  finishRequest(state);

export const onUpdateRegistrationEmails = (state: SystemAccessState) => () => startRequest(state);
export const onUpdateRegistrationEmailsSuccess = (state: SystemAccessState) => () =>
  finishRequest(state);
export const onUpdateRegistrationEmailsError = (state: SystemAccessState) => () =>
  finishRequest(state);

export const onGetDataSecurityGeneralSettingsSuccess = (state: SystemAccessState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  error: null,
  generalSettings: payload,
});

export const onGetDataSecurityGeneralSettingsError = (state: SystemAccessState) => ({
  payload,
}: Object) => ({
  ...state,
  error: payload,
});

export const onToggleSystemAccessPasswordResetModal = (state: SystemAccessState) => ({
  payload,
}: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showPasswordResetModal: payload,
  },
});

export const onToggleSystemAccessLogOutLockModal = (state: SystemAccessState) => ({
  payload,
}: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showLogOutLockModal: payload,
  },
});

export const onToggleAddIpRestrictionModal = (state: SystemAccessState) => ({
  payload,
}: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showAddIpRestrictionModal: payload,
  },
});

export const onToggleClientLogoModal = (state: SystemAccessState) => ({ payload }: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showClientLogoModal: payload,
  },
});

export const onToggleRegistrationEmailsModal = (state: SystemAccessState) => ({
  payload,
}: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showBulkRegistrationEmailsModal: payload,
  },
});

export const onGetClientLogoSuccess = (state: SystemAccessState) => ({ payload }: Object) => ({
  ...state,
  logoUrl: payload,
});

export const onGetBulkRegistrationEmailsSuccess = (state: SystemAccessState) => ({
  payload,
}: Object) => ({
  ...state,
  emails: payload,
});

export const onGetBulkRegistrationEmailsTargets = (state: SystemAccessState) => () =>
  startRequest(state);

export const onGetBulkRegistrationEmailsTargetsSuccess = (state: SystemAccessState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  bulkRegistrationEmailTargets: payload,
});

export const onGetBulkRegistrationEmailsTargetsError = (state: SystemAccessState) => () =>
  finishRequest(state);

export const onGetPlatformDataSecuritySuccess = (state: SystemAccessState) => ({
  payload,
}: Object) => ({
  ...state,
  registrationEmails: payload,
});

export const onGetPlatformDataSecurityError = (state: SystemAccessState) => ({
  payload,
}: Object) => ({
  ...state,
  error: payload,
});

export const onToggleStandardRegistrationEmailsModal = (state: SystemAccessState) => ({
  payload,
}: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showStandardRegistrationEmailsModal: payload,
  },
});

export const onGetClientLogoError = (state: SystemAccessState) => () => ({
  ...state,
  logoUrl: null,
});

export const onToggleRegistrationEmailsExportModal = (state: SystemAccessState) => ({
  payload,
}: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showBulkRegistrationEmailsExportModal: payload,
  },
});

export const onGetEmployeeRegistrationEmailsTargetsSuccess = (state: SystemAccessState) => ({
  payload,
}: Object) => ({
  ...state,
  employeeRegistrationEmailTargets: payload,
});

export const onToggleEmployeeRegistrationEmailsModal = (state: SystemAccessState) => ({
  payload,
}: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showEmployeeRegistrationEmailsModal: payload,
  },
});
